/**
 * Enum que representa o cliente que originou uma requisição de polling.
 */
export enum PollingRequestClient{
    DEVICE_SUMMARY = "DEVICE_SUMMARY",
    INFO_CONFIG = "INFO_CONFIG",
    GPON_ONUS = "GPON_ONUS",
    MANAGE_DEVICES = "MANAGE_DEVICES",
    DWDM_CIRCUIT_DIAGNOSTIC = "DWDM_CIRCUIT_DIAGNOSTIC"
}
